// @flow
// Operator State
import { initialState as operatorState } from 'hfty-operator-fertilizers'
import {
  BRANCH,
} from 'fc-model-fertilizers'

export default {
  [BRANCH]: {},
}

export const operatorInitialState = {
  ...operatorState,
}
